import axios from 'axios';
import {axiosConfigFile as config} from 'config/axiosConfig';

const {REACT_APP_API} = process.env;
const baseUrl = `${REACT_APP_API}/processlog`;

export const create = async ({processlog, perror, pwarning, pinfo, palert,poff,prake} = {}) => {
 const {data} = await axios.post(`${baseUrl}/?perror=${perror}&pwarning=${pwarning}&pinfo=${pinfo}&palert=${palert}&poff=${poff}&prake=${prake}`, processlog, config)
 return data
}

export const findAllByDate = async ({startDate, endDate, tipoDeProyecto, perror, pwarning, pinfo, palert,poff,prake} = {}) => {
 const {data} = await axios.get(`${baseUrl}/findAllByDate/?startDate=${startDate}&endDate=${endDate}&tipoDeProyecto=${tipoDeProyecto}&perror=${perror}&pwarning=${pwarning}&pinfo=${pinfo}&palert=${palert}&poff=${poff}&prake=${prake}`, config)
 return data
}

export const getOne = async ({id, perror, pwarning, pinfo, palert,poff,prake}= {}) => {
 const {data} = await axios.get(`${baseUrl}/${id}?perror=${perror}&pwarning=${pwarning}&pinfo=${pinfo}&palert=${palert}&poff=${poff}&prake=${prake}`, config)
 return data
}
